export default __webpack_public_path__ + "static/media/lavageService.c1e6b55a.png";